import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconsService {
  constructor() {
    const domSanitizer = inject(DomSanitizer);
    const matIconRegistry = inject(MatIconRegistry);

    // Register icon sets
    matIconRegistry.addSvgIconSetInNamespace(
      'mat_twotone',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-twotone.svg'),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'mat_outline',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-outline.svg'),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'mat_solid',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-solid.svg'),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'feather',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/feather.svg'),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'hero_outline',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-outline.svg'),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'hero_solid',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-solid.svg'),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'hero_mini',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-mini.svg'),
    );

    // Register custom icons
    const wineArkNamespace = 'wineark';
    matIconRegistry.addSvgIconInNamespace(
      wineArkNamespace,
      'bottle',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/custom_bottle.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineArkNamespace,
      'bottles',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/custom_bottles.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineArkNamespace,
      'search',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/custom_search.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineArkNamespace,
      'wine-glass',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/custom_wine-glass.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineArkNamespace,
      'stocktake',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/custom_stocktake.svg'),
    );

    //  Wine Types
    const wineTypeNamespace = 'marketplace-winetype';
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'aromatic_whites',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/AromaticWhites.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'cabernet_blend',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/CabernetBlend.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'cabernet_sauvignon',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/CabernetSauvignon.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'cabernet_shiraz',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/CabernetShiraz.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'champagne',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Champagne.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'chardonnay',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Chardonnay.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'grenache',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Grenache.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'pinot_noir',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/PinotNoir.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'riesling',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Riesling.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'sangiovese',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Sangiovese.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'semillon',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Semillon.svg'),
    );
    matIconRegistry.addSvgIconInNamespace(
      wineTypeNamespace,
      'shiraz',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Shiraz.svg'),
    );
  }
}
